export const SET_LOADING = 'SET_LOADING'
export const SET_LOADING_EXTENDED = 'SET_LOADING_EXTENDED'
export const SET_PERSONAL_STATE_VALUE = 'SET_PERSONAL_STATE_VALUE'
export const SET_SELECTED_ACCOUNTS = 'SET_SELECTED_ACCOUNTS'
export const CLEAR_STATE_DATA = 'CLEAR_STATE_DATA'
